'use client';

import { PageErrorBanner } from '@components/core/PageErrorBanner';

const ErrorPage = () => {
  return <PageErrorBanner />;
};

export default ErrorPage;
